import { render, staticRenderFns } from "./shopmenu.vue?vue&type=template&id=6333c7b3"
import script from "./shopmenu.vue?vue&type=script&lang=js"
export * from "./shopmenu.vue?vue&type=script&lang=js"
import style0 from "./shopmenu.vue?vue&type=style&index=0&id=6333c7b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports